import React ,{useState , useCallback , useEffect}from 'react';

import './NocRightPanel.css';

import AcNocAlarmSummary from './AcNocAlaramSummary';
import NOcChargerStatusLogsGraph from './NocChargerStatusLogsGraph';
import CustomNocLineGraph from './CustomNocLineGraph';
import AcNocStatusCards from './NocStatusCards';


interface IntervalData {
  y: number;
  name: string;
  x: number;
  x2: number;
  color: string;
  description?: string
}
interface INocRightPanelProps {

latestChargerDetails?: ILatestChargerDetails | null;
latestChargerAlarmDetails?: ILatestChargerAlarmDetails | null;
latestChargerDetailsLoader?: boolean;
// alarmPlotData: ICustomLinePlotData[] | null;
sessionPlotData: ICustomLinePlotData[] | null;
energyPlotData: ICustomLinePlotData[] | null;
uptimePlotData: ICustomLinePlotData[] | null;
nocDashboardConnectorStatusData?:IConnectorStatusData | null;
alarmDurationRef: React.MutableRefObject<string| null>;
selectedChargerRef: React.MutableRefObject<string | null>;
searchTermRef: React.MutableRefObject<string | null>;
}


const AcNocRightPanel: React.FC<INocRightPanelProps> = (props) => {
  const { latestChargerDetails,latestChargerAlarmDetails,latestChargerDetailsLoader,sessionPlotData,energyPlotData,uptimePlotData,nocDashboardConnectorStatusData,alarmDurationRef,selectedChargerRef,searchTermRef} = props
    const [connectorStatusLogsData, setConnectorStatusLogsData] = useState<IntervalData[][] | null>(null)
    const [categories, setCategories] = useState<string[] | null>(null)
    const adjustIntervals = useCallback((dataintervals: IntervalData[][], rangeStartTime: string, rangeEndTime: string): IntervalData[][] => {
      const adjustedIntervalsData: IntervalData[][] = [];
      dataintervals?.forEach(intervals => {
        const adjustedIntervals: IntervalData[] = [];
        if (intervals[0]?.x != Date?.parse(rangeStartTime)) {
          adjustedIntervals.push({
            y: intervals[0]?.y,
            name: intervals[0]?.name,
            x: Date?.parse(rangeStartTime),
            x2: intervals[0]?.x,
            color: 'var(--charger-status-idle-light-color)',
          })
        }
        for (let i = 0; i < intervals.length - 1; i++) {
          adjustedIntervals.push(intervals[i]);
          const currentX2 = intervals[i]?.x2;
          const nextX = intervals[i + 1]?.x;
  
          if (currentX2 !== nextX) {
            const insertIndex = adjustedIntervals.length;
            adjustedIntervals.splice(insertIndex, 0, {
              y: intervals[i]?.y,
              name: intervals[i]?.name,
              x: currentX2,
              x2: nextX,
              color: 'var(--charger-status-idle-light-color)',
            });
          }
        }
        adjustedIntervals.push(intervals[intervals.length - 1]);
        if (intervals[intervals.length - 1]?.x2 != Date.parse(rangeEndTime)) {
          adjustedIntervals.push({
            y: intervals[intervals.length - 1]?.y,
            name: intervals[intervals.length - 1]?.name,
            x: intervals[intervals.length - 1]?.x2,
            x2: Date.parse(rangeEndTime),
            color: 'var(--charger-status-idle-light-color)',
          })
        }
        adjustedIntervalsData.push(adjustedIntervals);
      });
      return adjustedIntervalsData;
    }, []);
  
  const calculateDataPointsForStatusLogs = useCallback(() => {
    const data: IntervalData[][] = [];
    const categories: string[] = [];
  
    const statusData = nocDashboardConnectorStatusData; 
    if (statusData && statusData?.connectorData?.length > 0) {
      const statusLog = statusData?.connectorData?.map((element, index) => {
        if (!element?.sessionLogs || element?.sessionLogs.length === 0) {
          categories.push('C' + (index + 1));
  
          return [{
            y: statusData?.connectorData?.length - index - 1,
            name: element?.connectorName,
            x: Date.parse(statusData?.startDateTime),
            x2: Date.parse(statusData?.endDateTime),
            color: 'var(--charger-status-idle-light-color)'
          }];
        }
  
        const log = element?.sessionLogs.map((sessionLog) => ({
          y: statusData?.connectorData.length - index - 1,
          name: element?.connectorName,
          x: Date.parse(sessionLog?.startedAt),
          x2: Date.parse(sessionLog?.finishedAt),
          description: sessionLog?.state,
          color: sessionLog?.colorCode ?? 'var(--charger-status-idle-light-color)'
        }));
  
        categories.push('C' + (index + 1));
        return log;
      });
  
      const modifiedData = adjustIntervals(
        statusLog,
        statusData.startDateTime,
        statusData.endDateTime
      );
  
      data.push(...modifiedData);
    }
  
    setCategories(categories.reverse());
    setConnectorStatusLogsData(data);
  }, [nocDashboardConnectorStatusData]);
  
  
    useEffect(() => {
      calculateDataPointsForStatusLogs()
    }, [nocDashboardConnectorStatusData])


  return (
    <div
    className = 'noc-right-panel-conatiner'
    >
      {latestChargerDetails && latestChargerAlarmDetails ? (
        <>
          <AcNocStatusCards
            chargerDetails={latestChargerDetails}
            alarmDetails={latestChargerAlarmDetails}
          />

          <AcNocAlarmSummary
            loader={latestChargerDetailsLoader}
            isNewDashBoard={false}
            alarmDetails={latestChargerAlarmDetails}
            alarmDurationRef={alarmDurationRef}
            selectedChargerRef={selectedChargerRef}
            searchTermRef={searchTermRef}
          />
       <NOcChargerStatusLogsGraph
  connectorStatusLogsData={connectorStatusLogsData ?? []}
  categories={categories ?? []}
/>
          <div className='noc-right-panel-charger-analytics-graph-container'>
            <CustomNocLineGraph plotData={sessionPlotData} yAxisLabel='Sessions' tooltipLabel='Sessions'/>
            <CustomNocLineGraph plotData={energyPlotData} yAxisLabel='Energy' tooltipLabel='Energy Delivered' unit='kWh'/>
            <CustomNocLineGraph plotData={uptimePlotData} yAxisLabel='Uptime'  tooltipLabel='Uptime' unit='%'/>
          </div>




          {/* <NocLatestAlert /> */}
           
        </>
      ) : (
        <p style={{ padding: '10px' }}>Loading...</p>
      )}
    </div>
  );
};

export default AcNocRightPanel;
